import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const HeaderMenuBackIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>返回6</title>
      <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="home-h5-侧拉导航栏" transform="translate(-200.000000, -113.000000)">
          <g id="返回6" transform="translate(200.000000, 113.000000)">
            <rect id="矩形" fill="#000000" fillRule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
            <path
              d="M1.28635937,7.98395312 C1.28635937,11.6958906 4.2928125,14.7047656 8.002,14.7047656 C11.7108437,14.7047656 14.7173125,11.6958906 14.7173125,7.98395312 C14.7173125,4.27198438 11.7108437,1.26309375 8.002,1.26309375 C4.2928125,1.26309375 1.28635937,4.27198438 1.28635937,7.98395312 L1.28635937,7.98395312 Z"
              id="形状"
              fill="#ED0070"
              fillRule="nonzero"
            ></path>
            <polyline
              id="路径-6"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="6.45266305 4.44508964 9.98289286 8 6.45266305 11.563899"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default HeaderMenuBackIcon;
